/**
 * Hook to fetch configured agents for the workspace
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { agentsApi, Agent, AgentManifest } from "../api";

export const useAgents = (params?: { channelId?: string }) => {
  return useQuery<Agent[], Error>({
    queryKey: params?.channelId
      ? ["ai-studio", "agents", "configured", "channel", params.channelId]
      : ["ai-studio", "agents", "configured"],
    queryFn: () => agentsApi.list(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};

export const useAgentCatalog = (): UseQueryResult<AgentManifest[], Error> => {
  return useQuery<AgentManifest[], Error>({
    queryKey: ["ai-studio", "agents", "catalog"],
    queryFn: () => agentsApi.getCatalog(),
    staleTime: 1000 * 60 * 60, // 1 hour - catalog doesn't change often
    retry: 2
  });
};
